const FAVORITE_HTML_ELEMENT_ID = "menu-item-127277"; //live
//const FAVORITE_HTML_ELEMENT_ID = "menu-item-119877" // staging
//const FAVORITE_HTML_ELEMENT_ID = "menu-item-101828"; // dev
const MOBILE_MENU_NAV_ID = "menu-account-navigation";
const MOBILE_FAVORITES_ELEMENT_ID = "menu-item-127321"; //staging
//const MOBILE_FAVORITES_ELEMENT_ID = "menu-item-85638"; //dev

export const addToNavigationFavoriteCount = (
   count: number,
   isMobile: boolean
) => {
   let favoritesElement = document.getElementById(FAVORITE_HTML_ELEMENT_ID)
      ?.children[0];
   if (!isMobile) {
      if (favoritesElement) {
         // Store the original innerHTML
         const originalInnerHTML = favoritesElement.innerHTML;
         const originalHref = favoritesElement.getAttribute("href");
         const originalClasses = favoritesElement.className;

         // Change the HTML content to show a loading spinner or any temporary content
         //favoritesElement.className = ""; // Remove all classes
         favoritesElement.setAttribute("href", "#");
         favoritesElement.innerHTML =
            '<div class="loader"></div><span style="margin-right: 35px;">Favorites</span>';

         // Wait for 1.5 seconds before setting the HTML back to the original, with the count updated
         setTimeout(() => {
            let favoritesCount = originalInnerHTML.match(/\d+/);
            if (favoritesCount) {
               favoritesElement!.innerHTML =
                  "Favorites (" + (parseInt(favoritesCount[0]) + count) + ")";
               favoritesElement!.setAttribute("href", originalHref!);
               //favoritesElement!.className = originalClasses; // Restore all original classes
            }
         }, 1500);
      }
   } else {
      // Removed toggle dropwodn menu on mobile device >>
      
      // let dropdownElement = document.getElementById(MOBILE_MENU_NAV_ID);
      // dropdownElement?.classList.add("dropdown-active");
      let mobileFavoritesElement = document.getElementById(
         MOBILE_FAVORITES_ELEMENT_ID
      )?.children[0];
      if (mobileFavoritesElement) {
         mobileFavoritesElement.innerHTML =
            '<div class="loader"></div><span>Favorites</span>';
      }
      const originalInnerHTML = favoritesElement!.innerHTML;
      let favoritesCount = originalInnerHTML.match(/\d+/);
      favoritesElement!.innerHTML =
         "Favorites (" + (parseInt(favoritesCount![0]) + count) + ")";
      setTimeout(() => {
         mobileFavoritesElement!.innerHTML =
            "Favorites (" + (parseInt(favoritesCount![0]) + count) + ")";
      }, 1500);
      // setTimeout(() => {
      //    dropdownElement!.classList.remove("dropdown-active");
      // }, 3000);
   }
};
